import * as Sentry from '@sentry/react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './Home';
import Authorization from './pages/Authorization';
import Redirect from './pages/Redirect';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/oauth" />} />
      <Route path="/home/*" element={<Home />} />
      <Route path="oauth" element={<Authorization />} />
      <Route path="/redirect" element={<Redirect />} />
    </Routes>
  );
};

export default Sentry.withProfiler(App);
